import Model from '@/models/Model';

export default class Config extends Model {
    get route () {
        return 'config';
    }

    static get className () {
        return 'Config';
    }

    static get isInStore () {
        return true;
    }
}
